/* istanbul ignore file */
import React from 'react';
import _, { compose, partial } from 'underscore';
import onClickOutside from 'react-onclickoutside';
import { TreeViewWithRCIDStorage } from '@bingads-webui-react/hierarcy-tree-view-with-rcid-storage';
import { CustomerAccountSelectorTreeView } from '@bingads-webui-react/customer-account-selector';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withSettingsConsumer } from '@bingads-webui-react/settings-context';
import { withUserConsumer } from '@bingads-webui-react/user-context';
import { withScope } from '@bingads-webui-react/scope-service';
import { getAccountBreadcrumbStyles } from '../../styles';
import { StyledAccountBreadcrumbBase } from './account-breadcrumb-base';

const AccountSelector = TreeViewWithRCIDStorage(CustomerAccountSelectorTreeView);

class AccountBreadcrumb extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDropdownMenu: false,
      showAccountSelectorView: false,
    };
  }

  setParentState = (state) => {
    this.setState(state);
  };

  hide() {
    this.setState({ showDropdownMenu: false });
  }

  handleClickOutside = () => {
    if (this.state.showAccountSelectorView || this.state.showDropdownMenu) {
      this.hide();
    }
  };

  render() {
    return (
      <StyledAccountBreadcrumbBase
        {...this.props}
        AccountSelector={AccountSelector}
        parentState={this.state}
        setParentState={this.setParentState}
      />
    );
  }
}

export const StyledAccountBreadcrumb = compose(
  withScope,
  partial(withDefaultStyles, _, getAccountBreadcrumbStyles),
  withUserConsumer,
  withSettingsConsumer,
  withI18nConsumer,
  onClickOutside
)(AccountBreadcrumb);
